import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { LinearProgress, Tooltip, IconButton, Snackbar } from '@material-ui/core';
import { LinkOff, Link, Report, ReportOff } from '@material-ui/icons';
import API from '../../../api-graphql';
import { CONSTANTS } from '../../../constants/constants';
import { Alert } from '@material-ui/lab';

const DontSignButton = (props) => {
  const { input, index } = props;
  const { t } = useTranslation();
  const attachment = input.annexes[index - 1];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [skipped, setSkipped] = useState(attachment && !!attachment.skip);
  const [addToCertifiedEvidence, setaddToCertifiedEvidence] = useState(Boolean(attachment.addToCertifiedEvidence));
  const tooltipText = skipped
    ? 'viewer:addSignature'
    : 'viewer:doNotSign';

  const tooltipTextCertifiedEvidence = addToCertifiedEvidence
    ? 'viewer:notAddToCertifiedEvidence'
    : 'viewer:addToCertifiedEvidence';

  async function handleClickSkip (e) {
    e.stopPropagation();
    setLoading(true);
    attachment.skip = !skipped;
    if (attachment.skip) {
      attachment.addToCertifiedEvidence = true;
      setaddToCertifiedEvidence(true);
    } else {
      delete attachment.addToCertifiedEvidence;
    }
    API.updateDocument(input)
      .then(() => setSkipped(!skipped))
      .catch(setError);
    setLoading(false);
  }

  async function handleClickAddToCertifiedEvidence (e) {
    e.stopPropagation();
    setLoading(true);
    attachment.addToCertifiedEvidence = !addToCertifiedEvidence;
    API.updateDocument(input)
      .then(() => setaddToCertifiedEvidence(!addToCertifiedEvidence))
      .catch(setError);
    setLoading(false);
  }

  if (input.status !== CONSTANTS.DOCUMENT.STATUS.INIT) return null;

  if (loading) {
    return (
      <div style={{ padding: 0, position: 'absolute', top: '100%', left: 0, width: '100%', zIndex: 9999, textAlign: 'center' }}>
        <LinearProgress />
      </div>
    );
  }

  return (
    <>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={setError}>
        <Alert severity='error'>
          {t('bundleUploadView:genericError')}
        </Alert>
      </Snackbar>
      <Tooltip disableFocusListener title={t(tooltipText)}>
        <span>
          <IconButton onClick={handleClickSkip} style={{ color: 'black' }} disabled={loading}>
            {skipped
              ? <LinkOff style={{ fontSize: '18px' }} />
              : <Link style={{ fontSize: '18px' }} />
            }
          </IconButton>
        </span>
      </Tooltip>
      {skipped && (
        <Tooltip disableFocusListener title={t(tooltipTextCertifiedEvidence)}>
          <span>
            <IconButton onClick={handleClickAddToCertifiedEvidence} style={{ color: 'black' }} disabled={loading}>
              {addToCertifiedEvidence
                ? <Report style={{ fontSize: '18px' }} />
                : <ReportOff style={{ fontSize: '18px' }} />
              }
            </IconButton>
          </span>
        </Tooltip>
      )
      }

  </>
  );
};

DontSignButton.propTypes = {
  input: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default DontSignButton;
